import {useFlowContributingAreas} from 'src/hooks/useFlowContributingAreas';
import {Site} from 'src/lib/api/project';
import {canUseBasinAveraging} from 'src/lib/siteUtils';

import {recordEvent} from './Analytics';
import {ButtonGroupSwitch} from './ButtonGroupSwitch';
import {useTranslations} from './TranslationsContext';

const IncludeFlowContributingAreasSwitch = ({
  site,
  basinAveragingEnabled,
  includeFlowContributingAreas,
  setIncludeFlowContributingAreas,
}: {
  site: Site | null;
  basinAveragingEnabled: boolean;
  includeFlowContributingAreas: boolean;
  setIncludeFlowContributingAreas: (value: boolean) => void;
}) => {
  const {t} = useTranslations();

  const {flowContributingAreas} = useFlowContributingAreas(
    basinAveragingEnabled ? site?.projectId : undefined
  );
  if (!canUseBasinAveraging(site, basinAveragingEnabled, flowContributingAreas)) {
    return null;
  }

  return (
    <ButtonGroupSwitch
      options={[
        {label: t('forecastPoint'), value: 'false'},
        {label: t('basinAverage'), value: 'true'},
      ]}
      selectedValue={includeFlowContributingAreas ? 'true' : 'false'}
      onChange={(value) => {
        const enabled = value === 'true';
        setIncludeFlowContributingAreas(enabled);
        recordEvent('basin_average_toggled', {enabled, siteId: site?.id || ''});
      }}
    />
  );
};

export default IncludeFlowContributingAreasSwitch;
